import { useEffect, useState } from "react";
import api from "./api";

// Small client cache for the Requirement dropdown list. The list is mutated
// only from Settings (admin-only) — anywhere else just reads the cached
// values via `useRequirements()`. Mutations from Settings push fresh data
// via `setRequirements(list)` so every consumer rerenders immediately.
let _cache = null;
let _promise = null;
const listeners = new Set();

export function fetchRequirements(force = false) {
  if (_cache && !force) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = api.get("/requirements")
      .then((r) => {
        _cache = r.data?.requirements || [];
        listeners.forEach((cb) => cb(_cache));
        return _cache;
      })
      .finally(() => { _promise = null; });
  }
  return _promise;
}

export function setRequirements(list) {
  _cache = Array.isArray(list) ? list : [];
  listeners.forEach((cb) => cb(_cache));
}

export function useRequirements() {
  const [reqs, setReqs] = useState(_cache || []);
  useEffect(() => {
    if (_cache) setReqs(_cache);
    else fetchRequirements().then(setReqs).catch(() => {});
    listeners.add(setReqs);
    return () => listeners.delete(setReqs);
  }, []);
  return reqs;
}
